/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:49
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('SiteView', ["$sce", "Site", "SiteSrv", "SiteData", "WorkingPeriodView", "Format", "AppData", "AppCode",
    function ($sce, Site, SiteSrv, SiteData, WorkingPeriodView, Format, AppData, AppCode) {

        var SiteView = function (site) {
            this.preposition = null;
            this.name = null;
            this.phone = null;
            this.emailContact = null;
            this.emailBooking = null;
            this.fax = null;
            this.address = null;
            this.postalCode = null;
            this.city = null;
            this.country = "FR";
            this.timeZone = "Europe/Paris";
            this.departement = null;
            this.siret = null;
            this.vatNumber = null;
            this.nafCode = null;
            this.rcs = null;
            this.webSiteDir = null;
            this.workingPeriodsView = [];
            this.googleMapUrl = null;
            this.ownerId = null;
            this.legalName = null;
            this.legalAddress = null;
            this.legalCity = null;
            this.legalZip = null;
            this.legalCountry = null;
            this.greffeCity = null;
            this.juridicForm = null;

            if (site != undefined && site) {
                this.loadDataFrom(site);
            }

        };
        SiteView.prototype.loadDataFrom = function (site) {
            this.name = site.name;
            this.preposition = site.preposition;
            this.phone = Format.formatNumber(site.phone);
            this.emailContact = site.emailContact;
            this.emailBooking = site.emailBooking;
            this.fax = site.fax;
            this.address = site.address;
            this.postalCode = site.postalCode;
            this.city = site.city;
            if (site.country)
                this.country = site.country;
            if (site.timeZone)
                this.timeZone = site.timeZone;
            this.siret = site.siret;
            this.vatNumber = site.vatNumber;
            this.rcs = site.rcs;
            this.shareCapital = site.shareCapital;
            this.nafCode = site.nafCode;
            this.webSiteDir = site.webSiteDir;
            this.ownerId = site.ownerId;
            this.legalName = site.legalName;
            this.legalAddress = site.legalAddress ? site.legalAddress : this.address;
            this.legalCity = site.legalCity ? site.legalCity : this.city;
            this.legalZip = site.legalZip ? site.legalZip : this.postalCode;
            this.legalCountry = site.legalCountry ? site.country : this.country;
            this.greffeCity = site.greffeCity;
            this.juridicForm = site.juridicForm;
            if (this.address && this.address !== "" && this.postalCode && this.postalCode !== "" && this.city && this.city !== "") {
                const GOOGLE_MAPS_FIELD_SEPARATOR = ",";
                const GOOGLE_MAPS_SPACE_ESCAPED = '+';
                let googleMapUrl = "https://www.google.com/maps/embed/v1/place?key=AIzaSyAae8fgXj1u1KmT2XPO0vVxTWL8WcdIK9A&q="
                    + this.address.replace(/\s/g, GOOGLE_MAPS_SPACE_ESCAPED)
                    + GOOGLE_MAPS_FIELD_SEPARATOR + this.postalCode.replace(/\s/g, GOOGLE_MAPS_SPACE_ESCAPED)
                    + GOOGLE_MAPS_FIELD_SEPARATOR + this.city.replace(/\s/g, GOOGLE_MAPS_SPACE_ESCAPED);
                // Google Maps need information to place on map
                // It can manage both country name and code
                if (this.country && this.country !== "")
                    googleMapUrl += GOOGLE_MAPS_FIELD_SEPARATOR + this.country.replace(/\s/g, GOOGLE_MAPS_SPACE_ESCAPED);

                this.googleMapUrl = $sce.trustAsResourceUrl(googleMapUrl);
            }
            this.departement = site.departement;
            this.workingPeriodsView = [];
            if (site.workingPeriods)
                for (var k = 0; k < site.workingPeriods.length; k++)
                    this.workingPeriodsView.push(new WorkingPeriodView(site.workingPeriods[k], k));

        }
        SiteView.prototype.copyDataTo = function (site) {
            //Assume here than the object in parameter contains only id (must load them)
            site.name = this.name;
            site.preposition = this.preposition;

            if (this.phone != undefined && this.phone != null) {
                if (this.phone[0] == '+') {
                    // if + : delete all spaces
                    do {
                        this.phone = this.phone.replace(" ", '');
                        site.phone = this.phone;
                    } while (this.phone.search(" ") != -1);
                } else {
                    site.phone = this.phone.replace(/[^0-9]/g, '');
                }
            }

            site.emailContact = this.emailContact;
            site.emailBooking = this.emailBooking;
            site.fax = this.fax;
            site.address = this.address;
            site.postalCode = this.postalCode;
            site.city = this.city;
            site.country = this.country;
            site.timeZone = this.timeZone;
            site.departement = this.departement;
            site.siret = this.siret;
            site.nafCode = this.nafCode;
            site.vatNumber = this.vatNumber;
            site.rcs = this.rcs;
            site.shareCapital = this.shareCapital;
            site.webSiteDir = this.webSiteDir;
            site.ownerId = this.ownerId;
            site.ownerEmail = this.ownerEmail;
            site.ownerMobile = this.ownerMobile;
            site.legalName = this.legalName;
            site.legalAddress = this.legalAddress;
            site.legalCity = this.legalCity;
            site.legalZip = this.legalZip;
            site.legalCountry = this.legalCountry;
            site.greffeCity = this.greffeCity;
            site.juridicForm = this.juridicForm;
        }

        SiteView.prototype.getModel = function () {
            return SiteData.defaultSite;
        }

        SiteView.prototype.updateModel = function (workingPeriodDayViewsToClose, successFunction, errorFunction) {
            let site = this.getModel();
            if (site == null) {
                site = new Site();
            }

            this.copyDataTo(site);

            for (var k = 0; k < this.workingPeriodsView.length; k++) {
                this.workingPeriodsView[k].updateModel(workingPeriodDayViewsToClose);
            }

            //manage deletion of workingPeriod
            let bsDeleted;
            let index = 0;
            for (let i = 0; i < site.workingPeriods.length;) {
                if (site.workingPeriods[i].id) {
                    bsDeleted = true;
                    for (let j = 0; j < this.workingPeriodsView.length && bsDeleted; j++) {
                        if (index == this.workingPeriodsView[j].modelIndex) {
                            bsDeleted = false;
                        }
                    }
                    if (bsDeleted) {
                        site.removeWorkingPeriod(site.workingPeriods[i]);
                    } else {
                        i++;
                    }
                } else {
                    i++;
                }
                index++;
            }
            for (let i = 0; i < this.workingPeriodsView.length; i++) {
                this.workingPeriodsView[i].modelIndex = i;//reset index
            }

            SiteSrv.save(site, successFunction, errorFunction);
        };
        SiteView.prototype.saveFromCompanyCode = function (companyCode) {
            let site = this.getModel();
            if (site) {
                this.copyDataTo(site);
                SiteSrv.saveFromCode(companyCode, site);
            }
        }

        SiteView.prototype.reloadModel = function () {
            var site = this.getModel();
            if (site) {
                this.loadDataFrom(site)
            }
        }

        SiteView.prototype.removeWorkingPeriodView = function (wpView) {
            var index = this.workingPeriodsView.indexOf(wpView);
            if (index != -1)
                this.workingPeriodsView.splice(index, 1);
        }
        SiteView.prototype.intersectWorkingPeriodsView = function (wpView) {
            var intersect = false;
            for (var i = 0; i < this.workingPeriodsView.length && !intersect; i++) {
                if (this.workingPeriodsView[i] !== wpView && this.workingPeriodsView[i].intersect(wpView))
                    intersect = true;
            }
            return intersect;
        }
        SiteView.prototype.addWorkingPeriodView = function (wpView) {
            var index = this.workingPeriodsView.indexOf(wpView);
            if (index == -1)
                this.workingPeriodsView.push(wpView);
        }

        SiteView.prototype.canSave = function (hasWebsiteAccess) {
            let isValid = this.name
                && this.name !== ''
                && this.workingPeriodsView.length > 0
                && this.ownerId
                && this.legalName
                && this.address
                && this.city
                && this.postalCode
                && this.phone

            if (isValid && hasWebsiteAccess) {
                isValid = this.emailContact && this.webSiteDir;
            }

            if (isValid && this.isFrance()) {
                isValid = this.siret
                    && this.vatNumber
            }

            if (isValid && this.checkAddressDifferentHeadOffice()) {
                isValid = this.legalAddress
                    && this.legalCity
                    && this.legalZip
                    && this.legalCountry
            }

            if (isValid && this.isAdvanceMng()) {
                isValid = this.rcs != null
            }
            return isValid
        }

        SiteView.prototype.checkAddressDifferentHeadOffice = function () {
            return this.address !== this.legalAddress ||
                this.city !== this.legalCity ||
                this.country !== this.legalCountry ||
                this.postalCode !== this.legalZip
        }
        SiteView.prototype.hasValidWorkPhone = function () {
            // if site has a valid work phone number
            if (this.phone == null || this.phone == "")
                return true;
            if (this.phone && this.phone.length > 0) {
                if (this.phone[0] == 0 && this.phone.replace(/[^0-9]/g, '').length == 10 && this.phone.length == 14) {
                    // if length with only numbers equals 10 and if the first number is 0
                    // french number
                    return true;
                }
                if (this.phone[0] == '+') {
                    // international number
                    return true;
                }
            }

            return false;
        }

        SiteView.prototype.updateVatNumber = function () {
            if (this.country === "FR") {
                let siret = this.siret;
                siret = siret.replace(/\s/g, '');
                let siren = siret && siret.length > 9 ? siret.substring(0, 9) : null;
                if (siren && !isNaN(siren)) {
                    let tvaCode = (siren % 97 * 3 + 12) % 97;
                    this.vatNumber = `${tvaCode}${siren}`;
                }
            }
        }

        SiteView.prototype.isFrance = function () {
            return this.country === "FR";
        }

        SiteView.prototype.isAdvanceMng = function () {
            let posApp = AppData.getAppByCode(AppCode.POS_APP);
            if (posApp !== null) {
                let isAdvanceAttr = posApp.getAppAttribute("advanceMng");
                return (isAdvanceAttr && isAdvanceAttr.value === "true");
            } else {
                return false;
            }
        }

        return SiteView;
    }]);



// WEBPACK FOOTER //
// ./js/services/views/SiteView.js